import React from "react";
import MUILink from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import MUIBreadcrumbs from "@material-ui/lab/Breadcrumbs";

import { HeroContainer } from "../HeroContainer";
import { BreadcrumbItem } from "../types";
import { Styles, withStyles } from "./styles";

export interface BreadcrumbsProps extends Styles {
  breadcrumbItems: BreadcrumbItem[];
}

const BreadcrumbsBase: React.FC<BreadcrumbsProps> = ({ classes, breadcrumbItems }) => {
  const totalItems = breadcrumbItems.length - 1;
  return (
    <HeroContainer>
      <MUIBreadcrumbs
        color="inherit"
        separator="›"
        aria-label="Breadcrumb"
        className={classes.breadcrumbs}
      >
        {breadcrumbItems.map(({ url, text }, index) =>
          index !== totalItems ? (
            <MUILink key={url} href={url} color="inherit" variant="caption">
              {text}
            </MUILink>
          ) : (
            <Typography key={url} color="inherit" variant="caption">
              {text}
            </Typography>
          )
        )}
      </MUIBreadcrumbs>
    </HeroContainer>
  );
};

const Breadcrumbs = withStyles(BreadcrumbsBase);

export { Breadcrumbs };
